import {
  ChakraBox as Box,
  ChakraTab as Tab,
  ChakraTabList as TabList,
  ChakraTabPanel as TabPanel,
  ChakraTabPanels as TabPanels,
  ChakraTabs as Tabs,
  ChakraHeading as Heading,
} from "@airhelp/react-ui-components";
import { AutocompleteForm } from "modules/common/components";
import { trackClickEvent } from "utils/trackingUtils";
import ItemForwardBooking from "../common/ItemForwardBooking";
import ItemUseBoardingPass from "../common/ItemUseBoardingPass";

const CustomTab = ({ eventLabel, text }: { eventLabel: string; text: string }) => {
  const trackTabButton = () => {
    trackClickEvent("Hero", eventLabel);
  };

  return (
    <Tab
      flex="1"
      onClick={trackTabButton}
      color="greyscale.500"
      borderColor="greyscale.400"
      _selected={{
        fontWeight: "medium",
        color: "primary.900",
        borderBottom: "2px",
        borderColor: "primary.500",
      }}
      _hover={{
        bg: "primary.100",
      }}
    >
      {text}
    </Tab>
  );
};

const NewWayOfClamingDesktop = () => (
  <Box maxWidth="623px" p={1.5} bg="greyscale.300" rounded="lg">
    <Heading m={2} variant="h5" as="h5" fontWeight="bold">
      Check your flight in 1 of 3 ways
    </Heading>
    <Tabs
      variant="unstyled"
      align="center"
      width="full"
      bg="greyscale.100"
      rounded="md"
      border="1px"
      borderColor="greyscale.400"
    >
      <TabList height={16} borderBottom="1px" borderColor="greyscale.400">
        <CustomTab eventLabel="CollapsibleInsertDetails" text="Insert details" />
        <CustomTab eventLabel="CollapsibleScanBoardingPass" text="Use boarding pass" />
        <CustomTab eventLabel="CollapsibleForwardBooking" text="Forward confirmation" />
      </TabList>

      <TabPanels p={2} minH="156px" display="flex" alignItems="center" alignContent="stretch">
        <TabPanel w="100%">
          <AutocompleteForm variant="medium" ctaVariant="primary" buttonText="Check Compensation" />
        </TabPanel>
        <TabPanel w="100%">
          <ItemUseBoardingPass />
        </TabPanel>
        <TabPanel w="100%">
          <ItemForwardBooking />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </Box>
);

export default NewWayOfClamingDesktop;
